import { atom } from 'jotai';

import { TwoFaEnablingWizardController, WizardStep } from './TwoFaEnablingWizard.types';

export const twoFaWizardStepState = atom<WizardStep>(WizardStep.codeScan);

export const twoFaWizardControllerState = atom<TwoFaEnablingWizardController>({});
